export default "__VITE_ASSET__DuX8633d__"